import React, { useMemo } from "react";
import StatisticUtils from "../../utils/StatisticUtils";
import formatMZN from "../../utils/formatMZN";
import { useTranslation } from "../../i18n/I18nContext";

const UnitCountSix = ({ dashboardData, loading }) => {
  const { t } = useTranslation();
  const data = dashboardData || {};

  const paymentStats = useMemo(
    () => StatisticUtils.getTotals(data.paymentsByDate || []),
    [data.paymentsByDate],
  );
  const overduePaymentsStats = useMemo(
    () => StatisticUtils.getTotals(data.overduePaymentsByDate || []),
    [data.overduePaymentsByDate],
  );
  const registrationStats = useMemo(
    () => StatisticUtils.getCountTotals(data.registrationsByDate || []),
    [data.registrationsByDate],
  );
  const totalStudants = useMemo(
    () =>
      (data.registrationsByDate || []).reduce(
        (sum, entry) => sum + parseInt(entry.count || "0", 10),
        0,
      ),
    [data.registrationsByDate],
  );

  const display = (value) => (loading ? "..." : value);

  return (
    <>
      <div className='col-xxl-3 col-xl-4 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 bg-gradient-end-6'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-2'>
                <span className='mb-0 w-48-px h-48-px bg-cyan-100 text-cyan-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <i className='ri-money-dollar-circle-fill' />
                </span>
                <div>
                  <h6 className='fw-semibold mb-2'>
                    {display(formatMZN(paymentStats.currentMonthAmount))}
                  </h6>
                  <span className='fw-medium text-secondary-light text-sm'>
                    {t('dashboard.card.totalTuition')}
                  </span>
                </div>
              </div>
            </div>
            <p className='text-sm mb-0'>
              {" "}
              <span className='text-cyan-600'>
                {display(formatMZN(paymentStats.todayAmount))}
              </span>{" "}
              {t('dashboard.card.receivedToday')}
            </p>
          </div>
        </div>
      </div>
      <div className='col-xxl-3 col-xl-4 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 bg-gradient-end-4'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-2'>
                <span className='mb-0 w-48-px h-48-px bg-lilac-100 text-lilac-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <i className='ri-group-fill' />
                </span>
                <div>
                  <h6 className='fw-semibold mb-2'>{display(totalStudants)}</h6>
                  <span className='fw-medium text-secondary-light text-sm'>
                    {t('dashboard.card.students')}
                  </span>
                </div>
              </div>
            </div>
            <p className='text-sm mb-0'>
              {" "}
              <span className='text-lilac-600'>{display(registrationStats.todayTotal)}</span>{" "}
              {t('dashboard.card.enrollmentsToday')}
            </p>
          </div>
        </div>
      </div>
      <div className='col-xxl-3 col-xl-4 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 bg-gradient-end-1'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-2'>
                <span className='mb-0 w-48-px h-48-px bg-primary-100 text-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <i className='ri-wallet-3-fill' />
                </span>
                <div>
                  <h6 className='fw-semibold mb-2'>
                    {display(paymentStats.currentMonthTotal)}
                  </h6>
                  <span className='fw-medium text-secondary-light text-sm'>
                    {t('dashboard.card.totalPayments')}
                  </span>
                </div>
              </div>
            </div>
            <p className='text-sm mb-0'>
              {" "}
              <span className='text-primary-600'>{display(paymentStats.todayTotal)}</span>{" "}
              {t('dashboard.card.paymentsToday')}
            </p>
          </div>
        </div>
      </div>
      <div className='col-xxl-3 col-xl-4 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 bg-gradient-end-1'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-2'>
                <span className='mb-0 w-48-px h-48-px bg-warning-100 text-warning-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <i className='ri-error-warning-fill' />
                </span>
                <div>
                  <h6 className='fw-semibold mb-2'>
                    {display(overduePaymentsStats.currentMonthTotal)}
                  </h6>
                  <span className='fw-medium text-secondary-light text-sm'>{t('dashboard.card.debts')}</span>
                </div>
              </div>
            </div>
            <p className='text-sm mb-0'>
              {" "}
              <span className='text-warning-600'>
                {display(formatMZN(overduePaymentsStats.currentMonthAmount))}
              </span>{" "}
              {t('dashboard.card.inDebt')}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnitCountSix;
